import React from 'react';
import { useStacklineTheme } from '@stackline/ui';
import { NoDataIcon } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { Typography } from '@mui/material';
import { NoneFoundIcon } from 'src/components/SvgIcons';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';

export interface SegmentNoDataPlaceholderProps {
  title: string;
  subtitle: string;
  maxWidth?: number;
}

/**
 * Placeholder for when there is no data for either segments or business units
 * on the segments page
 */
const SegmentNoDataPlaceholder = ({ title, subtitle, maxWidth = 244 }: SegmentNoDataPlaceholderProps) => {
  const theme = useStacklineTheme();

  return (
    <Flex gap="md" flexDirection="column" alignItems="start">
      <NoDataIcon
        icon={<NoneFoundIcon />}
        iconBackgroundStyle={{
          backgroundColor: theme.colors.secondaryGhost,
          opacity: 1
        }}
      />
      <Flex flexDirection="column" gap="xs" alignItems="start">
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: colors.darkBlue
          }}
          variant="subtitle1"
        >
          {title}
        </Typography>
        <div style={{ maxWidth: `${maxWidth}px` }}>
          <Text variant="body2">{subtitle}</Text>
        </div>
      </Flex>
    </Flex>
  );
};

export default SegmentNoDataPlaceholder;
